module.exports = __webpack_public_path__ + "img/greenvx.fb0e3eea.png";